// import axios from "axios";

// const GetAttendanceCard = async (month) => {
//   let formData = new FormData();
//   formData.append("P_MONTH", month);

//   let config = {
//     method: "post",
//     url: "Attendance/DTSGetAttendanceCard",
//     data: formData,
//   };

//   return axios.request(config).then((response) => {
//     return response;
//   });
// };

// const GetCdlBasedDivison = async (mcvDate, hadDate) => {
//   return axios
//     .get(`Attendancedashboard/GetCdlBasedDivison`, {
//       params: {
//         p_mcv_date: mcvDate,
//         p_had_date: hadDate,
//       },
//     })
//     .then((response) => {
//       return response;
//     });
// };

// const GetTraineeBasedTypes = async (hadDate) => {
//   return axios
//     .get(`Attendancedashboard/GetTraineeBasedTypes`, {
//       params: {
//         p_had_date: hadDate,
//       },
//     })
//     .then((response) => {
//       return response;
//     });
// };

// const GetTraineeDivisionAttendance = async (mcvDate, hadDate) => {
//   return axios
//     .get(`Attendancedashboard/GetTraineeDivisionAttendance`, {
//       params: {
//         p_mcv_date: mcvDate,
//         p_had_date: hadDate,
//       },
//     })
//     .then((response) => {
//       return response;
//     });
// };

// const GetAllAttendance = async (mcvDate, hadDate) => {
//   return axios
//     .get(`Attendance/DTSGetTimer`, {

//     })
//     .then((response) => {
//       return response;
//     });
// };

// const GetCDLWeekAttendance = async (hadDate) => {
//   return axios
//     .get(`Attendancedashboard/GetCDLWeekAttendance`, {
//       params: {
//         p_had_date: hadDate,
//       },
//     })
//     .then((response) => {
//       return response;
//     });
// };

// const GetCDLCategoryAtt = async (hadDate) => {
//   return axios
//     .get(`Attendancedashboard/GetCDLCategoryAtt`, {
//       params: {
//         p_had_date: hadDate,
//       },
//     })
//     .then((response) => {
//       return response;
//     });
// };

// const GetLoadBaAttendance = async () => {
//   return axios
//     .get(`Attendance/DTSGetLoadLBAttendance`, {
//     })
//     .then((response) => {
//       return response;
//     }); 
// };

// export default {
//   GetAttendanceCard,
//   GetCdlBasedDivison,
//   GetTraineeBasedTypes,
//   GetTraineeDivisionAttendance,
//   GetAllAttendance,
//   GetCDLWeekAttendance,
//   GetCDLCategoryAtt,
//   GetLoadBaAttendance
// };
import axios from "axios";

// Existing internal APIs 

const GetAttendanceCard = async (month) => {
  let formData = new FormData();
  formData.append("P_MONTH", month);
  let config = { method: "post", url: "Attendance/DTSGetAttendanceCard", data: formData };
  return axios.request(config).then((response) => response);
};

const GetCdlBasedDivison = async (mcvDate, hadDate) =>
  axios.get(`Attendancedashboard/GetCdlBasedDivison`, { params: { p_mcv_date: mcvDate, p_had_date: hadDate } });

const GetTraineeBasedTypes = async (hadDate) =>
  axios.get(`Attendancedashboard/GetTraineeBasedTypes`, { params: { p_had_date: hadDate } });

const GetTraineeDivisionAttendance = async (mcvDate, hadDate) =>
  axios.get(`Attendancedashboard/GetTraineeDivisionAttendance`, { params: { p_mcv_date: mcvDate, p_had_date: hadDate } });

const GetAllAttendance = async (mcvDate, hadDate) =>
  axios.get(`Attendance/DTSGetTimer`);

const GetCDLWeekAttendance = async (hadDate) =>
  axios.get(`Attendancedashboard/GetCDLWeekAttendance`, { params: { p_had_date: hadDate } });

const GetCDLCategoryAtt = async (hadDate) =>
  axios.get(`Attendancedashboard/GetCDLCategoryAtt`, { params: { p_had_date: hadDate } });

const GetLoadBaAttendance = async () =>
  axios.get(`Attendance/DTSGetLoadLBAttendance`);


const attendMe2 = axios.create({
  baseURL: "https://esystems.cdl.lk/backend/AttendMe2",
  // baseURL: "http://localhost:51976",
});

// Forward auth token from the default axios instance.
attendMe2.interceptors.request.use((config) => {
  const token =
    axios.defaults.headers.common["Authorization"] ||
    axios.defaults.headers.common["token"];
  if (token) config.headers["Authorization"] = token;
  return config;
});

const GetAllDivisions = async () =>
  attendMe2.get("/AttendanceBiz/GetAllDivisions");

const GetLocationsByDivision = async (divisionCode) =>
  attendMe2.get("/AttendanceBiz/GetLocationsByDivision", { params: { DivisionCode: divisionCode } });

const GetEmployeesAttendance = async (divisionCode, locationCode, pDate) =>
  attendMe2.get("/AttendanceBiz/GetEmployeesAttendance", {
    params: { DivisionCode: divisionCode, LocationCode: locationCode, p_date: pDate },
  });

const GetEmpLocationCount = async (divisionCode,date) =>
  attendMe2.get("/AttendanceBiz/GetEmpLocationCount", {
    params: { DivisionCode: divisionCode , p_date: date },
  });

const GetEmpDesignationCount = async (pDate) =>
  attendMe2.get("/DesignationBasedCount/GetDesignationAttendance", {
    params: { p_date: pDate },
  });

export default {
  GetAttendanceCard,
  GetCdlBasedDivison,
  GetTraineeBasedTypes,
  GetTraineeDivisionAttendance,
  GetAllAttendance,
  GetCDLWeekAttendance,
  GetCDLCategoryAtt,
  GetLoadBaAttendance,
  GetAllDivisions,
  GetLocationsByDivision,
  GetEmployeesAttendance,
  GetEmpLocationCount,
  GetEmpDesignationCount,
};